export const Users = {
    admin: "admin",
    user: "user",
    studioOwner: "studio-owner",
    subUser: "subuser"
}